import { Component, OnInit } from '@angular/core';
import { ProjectService, Project, OperatingArea } from '../../../services/project/project.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-trayectoria',
  templateUrl: './trayectoria.component.html',
  styleUrl: './trayectoria.component.scss'
})
export class TrayectoriaComponent implements OnInit {
  selectedCategory: OperatingArea = 'Público';
  categories: OperatingArea[] = ['Público', 'Industrial y Comercial', 'Salud'];
  projects: Project[] = [];

  constructor(private projectService: ProjectService) {}

  ngOnInit(): void {
    this.projectService.getProjects()
      .pipe(
        map((allProjects: Project[]) => this.extractTop4PerCategory(allProjects))
      )
      .subscribe((projects: Project[]) => {
        this.projects = projects;
      });
  }

  private extractTop4PerCategory(allProjects: Project[]): Project[] {
    const projectsByCategory = new Map<string, Project[]>();
    const maxProjectsPerCategory = 4;

    for (const project of allProjects) {
      const category = project.businessArea;
      
      if (!projectsByCategory.has(category)) {
        projectsByCategory.set(category, []);
      }
      
      const categoryProjects = projectsByCategory.get(category)!;
      if (categoryProjects.length < maxProjectsPerCategory) {
        categoryProjects.push(project);
      }
    }

    return Array.from(projectsByCategory.values()).flat();
  }

  get filteredProjects(): Project[] {
    return this.projects.filter(project => project.businessArea === this.selectedCategory);
  }

  selectCategory(category: OperatingArea): void {
    this.selectedCategory = category;
  }
}
